import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3Plus');

    const tabObj: any = {
        title: t('J_item_title'),
        desc: t('J_item_desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1738725989088/13%E6%8E%A5%E5%8F%A3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1738725948051/Frame%201000008674.jpg',
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection label={t('J_label')} title={t('J_title')} theme="black" />
            <ul className={`boxes`}>
                <li className={`box`}>
                    <div className="box-img">
                        <EfImg pc={tabObj.pc} h5={tabObj.h5} />
                    </div>
                    <div className="box-msg">
                        <div className="box-title">{tabObj.title}</div>
                        <div className="box-desc">{tabObj.desc}</div>
                    </div>
                </li>
            </ul>
        </div>
    );
}
